import * as api from "./api";
import { fieldText, type RefusedField, refusedField } from "./offline/messages";

export const SERVER_PROBLEM = "The server has a problem. Try again in a few minutes.";

export type Saved =
  | { ok: true; text: string }
  | { ok: false; text: string; field?: boolean; session?: boolean; at?: RefusedField | null; server?: string };

export function saveFailure(e: unknown, thing = "The pickup"): Saved {
  const status = e instanceof api.ApiError ? e.status : 0;
  if (status === 401) return { ok: false, session: true, text: "Your session ended." };
  if ([403, 409, 422, 502].includes(status) && e instanceof api.ApiError && e.detail) {
    return { ok: false, field: true, text: e.detail };
  }
  if (status >= 500) return { ok: false, text: SERVER_PROBLEM };
  return { ok: false, text: `${thing} was not saved. Check your connection, then try again. A retry does not add it twice.` };
}

/** The field of the Record a pickup form that a refused field names, or null. */
export function pickupField(field: RefusedField | null | undefined): "date" | "gallons" | "scrap" | null {
  return field === "time" ? "date" : field === "gallons" || field === "scrap" ? field : null;
}

/** As saveFailure, but a 403, 409 or 422 gives the plain text of rule U-17 and the field that it names; the server text is only for the office. */
export function plainFailure(e: unknown, thing = "The pickup"): Saved {
  if (!(e instanceof api.ApiError) || ![403, 409, 422].includes(e.status)) return saveFailure(e, thing);
  const detail = e.server ?? e.detail ?? null;
  return { ok: false, text: fieldText(e.status, detail), at: refusedField(e.status, detail), server: detail ?? `HTTP ${e.status}` };
}
